import { render, staticRenderFns } from "./RecordVirtualList.vue?vue&type=template&id=8105442e&"
import script from "./RecordVirtualList.vue?vue&type=script&lang=js&"
export * from "./RecordVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports